import { ITheme } from "@fluentui/react";
import { styled } from "styled-components";

export const OverrideValue = styled.span<{ theme: ITheme }>`
  color: ${props => props.theme.semanticColors.severeWarningIcon};
  font-weight: bold;
`;
